// CSS Modules - component class name: FormSelect__

<template>
  <div
    :class="[
      $style.container,
      { FormSelect__blue: this.colour === 'blue' },
      { FormSelect__error: this.error },
      { FormSelect__active: this.isActive }
    ]"
  >
    <label v-if="label" :class="$style.label">
      {{ label }}
      <span :class="$style.optional" v-if="optionalLabel">
        ({{ optionalLabel }})
      </span>
    </label>
    <div
      ref="input"
      :class="[$style.input, { FormSelect__disabled: this.disabled }]"
      @click="handleInputClick"
    >
      <span v-html="value"></span>
      <span :class="$style.triangle"></span>
    </div>
    <div
      ref="optionsContainer"
      v-show="isActive"
      :class="$style.optionsContainer"
      v-closable="{
        exclude: ['input', 'filter'],
        handler: 'handleOutsideClick'
      }"
    >
      <div v-if="hasFilter" ref="filter" :class="$style.filterContainer">
        <input v-model="filter" />
        <i class="fas fa-search"></i>
      </div>
      <ul :class="$style.options" ref="optionsList">
        <li
          v-for="(option, index) in filteredOptions"
          :id="`option${index}`"
          :class="[
            $style.option,
            { FormSelect__hover: selectedIndex === index && showSelectedHover }
          ]"
          :key="index"
          @click="() => handleOptionClick(option)"
          @mouseover="showSelectedHover = false"
        >
          <!-- This is uglier, but it gets rid of the spaces between the spans... -->
          <span v-html="option[0]"></span
          ><span :class="$style.highlighted" v-html="option[1]"></span
          ><span v-html="option[2]"></span>
        </li>
      </ul>
    </div>
    <div v-if="error" :class="$style.errorMessage">{{ errorMessage }}</div>
  </div>
</template>

<script>
import closable from "../../directives/Closable.directive";

export default {
  name: "FormSelect",
  props: {
    value: [String, Number],
    label: {
      type: String,
      default: ""
    },
    errorMessage: {
      type: String,
      default: ""
    },
    error: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    },
    initialOption: {
      type: [String, Number],
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hasFilter: {
      type: Boolean,
      default: false
    },
    colour: {
      type: String,
      default: ""
    },
    optionalLabel: String
  },
  data() {
    return {
      isActive: false,
      filter: "",
      selectedIndex: -1,
      showSelectedHover: false
    };
  },
  directives: {
    closable
  },
  computed: {
    filteredOptions: function() {
      const filteredOptions = this.options.filter(option => {
        return (
          this.filter === "" ||
          option.toLowerCase().indexOf(this.filter.toLowerCase()) !== -1
        );
      });
      const dataOptions = filteredOptions.map(option => {
        const optionLength = option.length;
        const filterLength = this.filter.length;
        const startPosition = option
          .toLowerCase()
          .indexOf(this.filter.toLowerCase());
        if (this.filter === "") {
          return [option, "", ""];
        } else if (startPosition === 0 && filterLength < optionLength) {
          return [
            "",
            option.substr(startPosition, filterLength),
            option.substring(filterLength, optionLength)
          ];
        } else if (startPosition === 0 && filterLength === optionLength) {
          return ["", option, ""];
        } else if (
          startPosition > 0 &&
          filterLength + startPosition < optionLength
        ) {
          return [
            option.substring(0, startPosition),
            option.substr(startPosition, filterLength),
            option.substring(filterLength + startPosition, optionLength)
          ];
        } else {
          return [
            option.substring(0, startPosition),
            option.substring(startPosition, optionLength),
            ""
          ];
        }
      });
      return dataOptions;
    }
  },
  mounted() {
    if (this.initialOption) {
      this.options.filter((option, index) => {
        if (this.initialOption === option) {
          this.selectedIndex = index;
          return null;
        }
      });
    }
  },
  methods: {
    handleInputClick() {
      if (!this.disabled) {
        this.isActive = !this.isActive;
        if (this.isActive && this.selectedIndex > -1) {
          setTimeout(() => {
            this.showSelectedHover = true;
            if (this.selectedIndex > 6) {
              const list = this.$refs.optionsList;
              const scrollTo = (this.selectedIndex - 6) * 30;
              list.scrollTo(0, scrollTo);
            }
          }, 0);
        } else if (!this.isActive) {
          this.showSelectedHover = false;
          this.filter = "";
        }
      }
    },
    handleOutsideClick() {
      this.isActive = false;
      this.filter = "";
    },
    handleOptionClick(option) {
      this.$emit("input", option.join(""));
      this.options.filter((propOption, index) => {
        if (option.join("") === propOption) {
          this.selectedIndex = index;
        }
      });
      this.isActive = false;
      this.filter = "";
    }
  }
};
</script>

<style module lang="scss">
@import "./FormSelect.scss";
</style>
